export function getCookieValue(name) {
  return (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  )
}
export function getProxyAccessToken() {
  return getCookieValue('accessToken')
}
